import { render } from "./IconSidebar.vue?vue&type=template&id=0466889a&scoped=true"
import script from "./IconSidebar.vue?vue&type=script&lang=js"
export * from "./IconSidebar.vue?vue&type=script&lang=js"

import "./IconSidebar.vue?vue&type=style&index=0&id=0466889a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0466889a"]])

export default __exports__